import { PATHS } from "./networks.js";

/** Le logo d'un réseau dans un carré 24 × 24 (le cercle qui l'entoure est celui de l'appelant). */
export function NetworkLogo({ platform }: { platform: string }) {
  const d = PATHS[platform];
  if (!d) return null;
  const glyph = (fill: string, dx = 0) => <path d={d} fill={fill} transform={`translate(${6 + dx} ${6 + dx}) scale(.5)`} />;
  return (
    <svg viewBox="0 0 24 24" className={`net net-${platform}`} aria-hidden="true">
      {platform === "instagram" && (
        <defs>
          <radialGradient id="net-ig" cx="20%" cy="105%" r="130%">
            <stop offset="0" stopColor="#FEDA75" /><stop offset=".22" stopColor="#FA7E1E" /><stop offset=".48" stopColor="#D62976" /><stop offset=".74" stopColor="#962FBF" /><stop offset="1" stopColor="#4F5BD5" />
          </radialGradient>
        </defs>
      )}
      <rect width="24" height="24" fill={platform === "instagram" ? "url(#net-ig)" : platform === "tiktok" ? "#000" : "#fff"} />
      {platform === "tiktok" ? (<>{glyph("#25F4EE", -0.35)}{glyph("#FE2C55", 0.35)}{glyph("#fff")}</>) : glyph(platform === "instagram" ? "#fff" : "#FF0000")}
    </svg>
  );
}
